module.exports = __webpack_public_path__ + "img/italy-diseases-of-the-nervous-system-male.b4e22ba8.png";